import { FC } from 'react';
import useVideoStore from '@/stores/videoStore';
import { DocumentChapter } from '@/types/note';
import DocumentChapters from '../DocumentChapters/DocumentChapters';

interface VideoChaptersProps {
  chapters: DocumentChapter[];
  isProcessing: boolean;
  isOwner?: boolean;
  onChaptersUpdate?: (chapters: DocumentChapter[]) => Promise<void>;
}

const VideoChapters: FC<VideoChaptersProps> = ({ chapters, isProcessing, isOwner = false, onChaptersUpdate }) => {
  const { setVideoCurrentTime, setProgressCurrentTime, setProgressTime } = useVideoStore();

  const handleLinkClick = (time: number) => {
    setVideoCurrentTime(time);
    setProgressCurrentTime(time);
    setProgressTime();
  };

  return (
    <DocumentChapters
      chapters={chapters}
      handleChapterClick={handleLinkClick}
      isProcessing={isProcessing}
      isOwner={isOwner}
      onChaptersUpdate={onChaptersUpdate}
    />
  );
};

export default VideoChapters;
